<template>
  <div class="flex md:mb-1 xs:items-center items-start flex-col xs:flex-row">
    <div v-if="dateFilterCategory === 'month'">
      <div>
        <select
          :id="monthOfMonthAndYearId"
          name="monthOfMonthAndYear"
          :value="monthOfMonthAndYear"
          @change="handleDateChange"
          class="form-select py-2 px-2 text-sm rounded-md ring-1 ring-gray-300 text-gray-290 bg-gray-lightest focus:outline-none cursor-pointer"
        >
          <option
            v-for="month in months"
            :key="month.label"
            :value="month.value"
          >
            {{ month.label }}
          </option>
        </select>

        <select
          :id="yearOfMonthAndYearId"
          name="yearOfMonthAndYear"
          :value="yearOfMonthAndYear"
          @change="handleDateChange"
          class="form-select py-2 px-2 text-sm rounded-md ring-1 ring-gray-300 text-gray-290 bg-gray-lightest focus:outline-none cursor-pointer ml-2"
        >
          <option v-for="year in years" :key="year">{{ year }}</option>
        </select>
      </div>
    </div>

    <div v-else-if="dateFilterCategory === 'year'">
      <select
        :id="yearId"
        name="year"
        :value="year"
        @change="handleDateChange"
        class="form-select py-2 px-2 text-sm rounded-md ring-1 ring-gray-300 text-gray-290 bg-gray-lightest focus:outline-none cursor-pointer"
      >
        <option v-for="year in years" :key="year">{{ year }}</option>
      </select>
    </div>
    <div v-else class="text-sm text-gray-290">
      <input
        type="date"
        :max="endDate"
        :value="startDate"
        @change="handleDateChange"
        :id="startDateId"
        class="py-2 px-2 text-sm rounded-md ring-1 ring-gray-300 text-gray-290 bg-gray-lightest focus:outline-none cursor-pointer"
      />
      <span class="mx-1">-</span>

      <input
        type="date"
        :min="startDate"
        :value="endDate"
        @change="handleDateChange"
        :id="endDateId"
        class="py-2 px-2 text-sm rounded-md ring-1 ring-gray-300 text-gray-290 bg-gray-lightest focus:outline-none cursor-pointer"
      />
    </div>
    <div class="xs:ml-2 mt-4 xs:mt-0">
      <select
        id="dateCategory"
        name="dateCategory"
        class="form-select py-2 px-3 rounded-md text-sm ring-1 ring-green-light bg-green-light text-white focus:outline-none cursor-pointer hover:bg-white hover:text-green-light"
        :value="dateFilterCategory"
        @change="handleDateFilterCategoryChange"
      >
        <option
          value="month"
          class="bg-gray-lightest text-gray-290 cursor-pointer"
        >
          MONTH
        </option>
        <option
          value="year"
          class="bg-gray-lightest text-gray-290 cursor-pointer"
        >
          YEAR
        </option>
        <!-- <option
          value="custom"
          class="bg-gray-lightest text-gray-290 cursor-pointer"
        >
          CUSTOM
        </option> -->
      </select>
    </div>
  </div>
</template>
<script>
export default {
  name: "DateFilter",
  props: {
    handleDateChange: Function,
    handleDateFilterCategoryChange: Function,
    dateFilterCategory: String,
    monthOfMonthAndYear: Number,
    yearOfMonthAndYear: Number,
    year: [Number, String],
    startDate: String,
    endDate: String,
    startDateId: String,
    endDateId: String,
    yearId: String,
    monthOfMonthAndYearId: String,
    yearOfMonthAndYearId: String,
    //months: Array,
    //years: Array
  },
  data() {
    return {
      months: [
        { label: "January", value: 0 },
        { label: "February", value: 1 },
        { label: "March", value: 2 },
        { label: "April", value: 3 },
        { label: "May", value: 4 },
        { label: "June", value: 5 },
        { label: "July", value: 6 },
        { label: "August", value: 7 },
        { label: "September", value: 8 },
        { label: "October", value: 9 },
        { label: "November", value: 10 },
        { label: "December", value: 11 },
      ],
      years: [],
    };
  },
  methods: {
    populateYears() {
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const years = [];
      for (var i = 0; i <= 2; i++) {
        years.push(currentYear - i);
      }
      this.years = years;
    },
  },
  created() {
    this.populateYears();
  },
};
</script>